import CityPageTemplate from "../city-template/CityPageTemplate";
import { irvineConfig } from "./data";

export default function IrvinePage() {
  return <CityPageTemplate config={irvineConfig} />;
}